// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";

// Import utils
import {mapStateToProps} from "../../../redux/mapStateToProps";
import {
    GetPartnerCategories,
    DeletePartnerCategoryById,
    UpdatePartnerCategoryById,
} from "../../../redux/actions";

// Import components
import {NestableItem} from "../../../components/cards/nestableItem";
import {deleteItem} from "../../../utils/helperFunctions";


class PartnerCategories extends Component {
    constructor(props) {
        super(props);
        this.deleteCategoryItem = this.deleteCategoryItem.bind(this);
    }

    componentDidMount() {
        this.props.GetPartnerCategories();
    }

    deleteCategoryItem(id){
        this.props.DeletePartnerCategoryById(id)
    }

    getNestableItems(list, parent = null) {
        const items = [];
        list && !!list.length && list.forEach((item, index) => {
            const title = item?.title || '';

            items.push({
                id: item.id,
                index: index,
                title: title,
                isHidden: item.is_hidden,
                link: {
                    pathname: `categories/edit/${item.id}`,
                },
                deleteCb: deleteItem.bind(this, this.deleteCategoryItem, 'կատեգորիան', item.id),
                children:  []
            })
        });
        return items;
    }


    render() {
        let {partnerCategoriesList} = this.props;
        let items = this.getNestableItems(partnerCategoriesList);
        return <>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                handler={()=>{}}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </>
    }
}

const mapDispatchToProps = {
    GetPartnerCategories,
    DeletePartnerCategoryById,
    UpdatePartnerCategoryById,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerCategories);
